import React from 'react';
import {env} from "../../config/environment";
import i18n from "i18next";
import {DashboardContainer, Header, LogoWrapper} from "./Dashboard.styled";
import {brand} from "../../theme/brand";
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

const Dashboard = () => {
    const {t} = useTranslation();
    const { clientTheme } = env;
    const chatDescription = `brand.${clientTheme}.description`;
    const hasDescription = i18n.exists(chatDescription);

    return (
        <DashboardContainer>
            <Header $isBigSpace={true}>
                {t(`brand.${clientTheme}.chatLabel`)}
            </Header>

            {hasDescription && (
                <Typography variant="body1" component="span" mb={5} textAlign="center" color="text.hint">
                    {t(chatDescription)}
                </Typography>
            )}

            <LogoWrapper>
                <img src={brand.logo} alt="Trusted AI Assistant Logo"/>
            </LogoWrapper>
        </DashboardContainer>
    );
};

export default Dashboard;